import { connect } from "react-redux";
import get from "lodash/get";

import {
  getDrivers as onGetDrivers,
  selectDriver as onSelectDriver,
  createDriver as onCreateDriver,
  updateDriver as onUpdateDriver,
  deleteDriver as onDeleteDriver,
  selectDriverForUnits as onSelectDriverForUnits,
  downloadDrivers as onDownloadDrivers,
} from "../../actions/driversAction";

const mapStateToProps = (state) => ({
  driversDataState: state.drivers.driversDataState,
  driverCreateDataState: state.drivers.driverCreateDataState,
  driverUpdateDataState: state.drivers.driverUpdateDataState,
  driverDeleteDataState: state.drivers.driverDeleteDataState,
  driversDownloadDataState: state.drivers.driversDownloadDataState,
  drivers: get(state, ["drivers", "drivers"], []),
  selectedDriver: get(state, ["drivers", "selectedDriver"], null),
  driverForUnits: get(state, ["drivers", "driverForUnits"], null),
});

const mapDispatchToProps = {
  onGetDrivers,
  onSelectDriver,
  onCreateDriver,
  onUpdateDriver,
  onDeleteDriver,
  onSelectDriverForUnits,
  onDownloadDrivers,
};

const withDrivers = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withDrivers };
